import { InvestmentDataTypes } from '../api/schema'
import { ListInvestmentCard } from './list-investment-card'

export const WaitlistInvestmentCard = ({
  investment,
}: {
  investment: InvestmentDataTypes
}) => (
  <ListInvestmentCard
    investment={investment}
    badgeText="On Waitlist"
    menuUrl={investment?.waitlist_details?.url ?? ''}
    listName="waitlist"
  />
)
